import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import IframePage from "./IframePage";
import "./ScientiaProducts.less";
import ProposalSubmission from "./ProposalSubmission";
import ModelingWorkbenchApps from "./ModelingWorkbenchApps";
import InsightEngineApps from "./InsightEngineApps";
import LimsApps from "./LimsApps";
import Lims from "./Lims";
import Data from "./Data";
import Workbench from "./Workbench";
import InsightEngine from "./InsightEngine";
import Circles from "./Circles";
import {useLocation} from "react-router-dom";

interface ScientiaProductsProps {
  urlParam: string | null;
  onExternalLinkClick: (url: string) => void;
  currentUser: any;
  isTahomaUser: any;
  urlMap: any;
  deleteAllJupyterHubServers: () => Promise<string>;
  getActiveJupyterHubServerList: (server: string) => Promise<boolean>;}

export function checkPNNLStaff(currentUser: any): boolean {
  if (!currentUser || !currentUser.user_email) {
    return false; 
  }
  const email = currentUser.user_email;
  return email.endsWith("@pnnl.gov") || email.endsWith("@pnl.gov");
}

const ScientiaProducts: React.FC<ScientiaProductsProps> = (props) => {
  const { urlParam = null,
        onExternalLinkClick = () => {},
        isTahomaUser = null,
        urlMap = null,
        currentUser = null,
        deleteAllJupyterHubServers,
        getActiveJupyterHubServerList } = props || {};
  
  const [activeUrlParam, setActiveUrlParam] = useState<string | null>(urlParam);

  useEffect(() => {
    setActiveUrlParam(urlParam)
  }, [urlParam]);

  const handleExternalLinkClick = (url: string, e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onExternalLinkClick(url);
  };
  const handleOpenData = (e: any) => {
    handleExternalLinkClick(process.env.REACT_APP_DATA as string, e);
  }
  const handleProposal = (e: any) => {
    handleExternalLinkClick(process.env.REACT_APP_PROPOSAL_MANAGEMENT as string, e);
  }
  const handleLIMS = (e: any) => {
    handleExternalLinkClick('LIMS_CARDS', e);
  }
  const handleWorkBench = (e: any) => {
    handleExternalLinkClick('MODELING_WORKBENCH_CARDS', e);
  }  
  const handleInsight = (e: any) => {
    handleExternalLinkClick('INSIGHT_ENGINE_CARDS', e);
  }

  // commenting for future use; slack workspace integration
  // const[classNameValue, setClassNameValue] = useState('');
  // const currentUserEmail = currentUser?.user_email;
  // useEffect(() => {
  //   const fetchClassName = async () => {
  //     try {
  //       const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/getSlackUsers`);
  //       const users = response.data.users;
  //       const emails = users.map((user: { profile: { email: any; }; }) => user.profile?.email).filter((email: any) => email);
  //       const className = emails.includes(currentUserEmail) ? "clickable" : '';
  //       setClassNameValue(className);
  //     } catch (error) {
  //       console.error("Error fetching users of workspace", error);
  //     }
  //   }
  //   fetchClassName();
  // }, [currentUserEmail])

  const location = useLocation();

  useEffect(() => {
    const handleBackNavigation = () => {
      setActiveUrlParam("ALL_CARDS");
      window.history.replaceState(null, "", "/");
    }
    window.addEventListener("popstate", handleBackNavigation);
    return () => {
      window.removeEventListener("popstate", handleBackNavigation);
    }
  }, [location.search]);

  return (
    <div className={`product-section ${currentUser ? "fullvh" : "loggedout-product-section"}`}>

      {(activeUrlParam && activeUrlParam !== "ALL_CARDS" && activeUrlParam !== "MODELING_WORKBENCH_CARDS" && activeUrlParam !== "INSIGHT_ENGINE_CARDS" && activeUrlParam !== "LIMS_CARDS") && <IframePage url={activeUrlParam} currentUser={currentUser} urlMap={urlMap} onExternalLinkClick={handleExternalLinkClick}/>} 

      {(!activeUrlParam || activeUrlParam === "ALL_CARDS") && (
      <div className="product-brief-intro main-padding">
      {(currentUser && (
        <div className="title-wrapper-main">
            <div className="crumbs-main">
                All Modules
            </div><br />
        </div>
      ))}
      <span style={{ display: 'block', height: '20px' }} />
       <Row gutter={[{ xs: 8, sm: 8, md: 16, lg: 16 }, { xs: 8, sm: 8, md: 16, lg: 16 }]} >
        <Col  xs={24} sm={24} md={24} lg={16} xl={8} className="clickable">
          <div onClick={handleProposal} id="proposal_submission_card">
            <ProposalSubmission currentUser={currentUser} />
          </div>
        </Col>
        <Col  xs={24} sm={24} md={24} lg={16} xl={8} className="clickable">
         <div onClick={handleLIMS} id="lims_card">
            <Lims currentUser={currentUser} />    
         </div>
        </Col>
        <Col  xs={24} sm={24} md={24} lg={16} xl={8} className="clickable"> 
          <div onClick={handleOpenData} id="data_portal_card">
            <Data currentUser={currentUser} />
          </div>
        </Col>
        <Col xs={24} sm={24} md={24} lg={16} xl={8} className="clickable">
          <div onClick={handleWorkBench} id="workbench_card">
            <Workbench currentUser={currentUser} />
          </div>
        </Col>
        <Col  xs={24} sm={24} md={24} lg={16} xl={8} className="clickable">
          <div onClick={handleInsight} id="insight_card">
			      <InsightEngine currentUser={currentUser} />
          </div>
        </Col>
        <Col  xs={24} sm={24} md={24} lg={16} xl={8}>
            <Circles currentUser={currentUser} />
        </Col>
      </Row>
    </div>
    )}
    {(activeUrlParam === "MODELING_WORKBENCH_CARDS") && (
      <ModelingWorkbenchApps onExternalLinkClick={handleExternalLinkClick} isTahomaUser={isTahomaUser} deleteAllJupyterHubServers={deleteAllJupyterHubServers} getActiveJupyterHubServerList={getActiveJupyterHubServerList}/>
    )}
    {(activeUrlParam === "INSIGHT_ENGINE_CARDS") && (
      <InsightEngineApps onExternalLinkClick={handleExternalLinkClick} deleteAllJupyterHubServers={deleteAllJupyterHubServers} getActiveJupyterHubServerList={getActiveJupyterHubServerList}/>
    )}
    {(activeUrlParam === "LIMS_CARDS") && (
      <LimsApps onExternalLinkClick={handleExternalLinkClick} currentUser={currentUser} />
    )}
    </div>
  );
};
export default ScientiaProducts;
